import React, { useState } from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { miscAPI } from '../../api';
import Breadcrumbs from '../layout/Breadcrumbs';
import { toast } from 'sonner';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await miscAPI.submitContact(form);
      setSent(true);
      toast.success('Message sent!');
    } catch { toast.error('Failed to send'); } finally { setSending(false); }
  };

  return (
    <div className="pw-container py-2 pb-12">
      <Breadcrumbs items={[{ label: 'Contact Us' }]} />
      <h1 className="text-2xl font-semibold tracking-wider uppercase mb-8">Contact Us</h1>
      <div className="grid md:grid-cols-2 gap-12">
        <div>
          {sent ? (
            <div className="bg-[#e7f1ea] rounded-xl p-8 text-center">
              <p className="text-[#2f6b4f] font-medium text-lg">Thank you!</p>
              <p className="text-sm text-[#6f6a63] mt-2">We'll get back to you shortly.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="text-xs text-[#6f6a63] block mb-1">Name *</label>
                  <input id="contact-name" type="text" autoComplete="name" maxLength={200} required value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} className="w-full px-4 py-3 border border-[#e7e3dd] rounded-lg text-sm focus:outline-none focus:border-[#2f6b4f]" />
                </div>
                <div>
                  <label htmlFor="contact-email" className="text-xs text-[#6f6a63] block mb-1">Email *</label>
                  <input id="contact-email" type="email" autoComplete="email" required value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} className="w-full px-4 py-3 border border-[#e7e3dd] rounded-lg text-sm focus:outline-none focus:border-[#2f6b4f]" />
                </div>
              </div>
              <div>
                <label htmlFor="contact-phone" className="text-xs text-[#6f6a63] block mb-1">Phone</label>
                <input id="contact-phone" type="tel" autoComplete="tel" maxLength={50} value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} className="w-full px-4 py-3 border border-[#e7e3dd] rounded-lg text-sm focus:outline-none focus:border-[#2f6b4f]" />
              </div>
              <div>
                <label htmlFor="contact-subject" className="text-xs text-[#6f6a63] block mb-1">Subject</label>
                <input id="contact-subject" type="text" maxLength={200} value={form.subject} onChange={(e) => setForm(f => ({ ...f, subject: e.target.value }))} className="w-full px-4 py-3 border border-[#e7e3dd] rounded-lg text-sm focus:outline-none focus:border-[#2f6b4f]" />
              </div>
              <div>
                <label htmlFor="contact-message" className="text-xs text-[#6f6a63] block mb-1">Message *</label>
                <textarea id="contact-message" required maxLength={10000} rows={5} value={form.message} onChange={(e) => setForm(f => ({ ...f, message: e.target.value }))} className="w-full px-4 py-3 border border-[#e7e3dd] rounded-lg text-sm focus:outline-none focus:border-[#2f6b4f] resize-none" />
              </div>
              <button type="submit" disabled={sending} className="bg-[#2d2d2d] text-white px-8 py-3 rounded-lg text-sm tracking-wider uppercase disabled:opacity-50">{sending ? 'Sending...' : 'Send Message'}</button>
            </form>
          )}
        </div>
        <div className="space-y-6">
          <div className="flex gap-3"><Phone size={18} className="text-[#2f6b4f] mt-0.5" /><div><p className="text-sm font-medium">Phone</p><p className="text-sm text-[#6f6a63]">Retail Direct: 204-786-7750</p><p className="text-sm text-[#6f6a63]">Local: 204-786-1801</p><p className="text-sm text-[#6f6a63]">Toll Free Fax: 1-800-818-4977</p></div></div>
          <div className="flex gap-3"><Mail size={18} className="text-[#2f6b4f] mt-0.5" /><div><p className="text-sm font-medium">Email</p><p className="text-sm text-[#6f6a63]">gin@petalswest.com</p></div></div>
          <div className="flex gap-3"><MapPin size={18} className="text-[#2f6b4f] mt-0.5" /><div><p className="text-sm font-medium">Address</p><p className="text-sm text-[#6f6a63]">1-975 Sherwin Rd<br/>Winnipeg, MB R3H 0T8</p></div></div>
          <div className="flex gap-3"><Clock size={18} className="text-[#2f6b4f] mt-0.5" /><div><p className="text-sm font-medium">Hours</p><p className="text-sm text-[#6f6a63]">Monday - Friday: 6:00 AM - 3:00 PM<br/>Saturday: 6:00 AM - 12:00 PM<br/>Sunday: Closed</p></div></div>
        </div>
      </div>
    </div>
  );
}
